import { render, staticRenderFns } from "./Settinguser.vue?vue&type=template&id=26b71176&scoped=true&"
import script from "./Settinguser.vue?vue&type=script&lang=js&"
export * from "./Settinguser.vue?vue&type=script&lang=js&"
import style0 from "./Settinguser.vue?vue&type=style&index=0&id=26b71176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b71176",
  null
  
)

export default component.exports